import styled, { keyframes } from 'styled-components';
import { getSpace, getColor, mq, gridContainer, setGridColumns } from '../../../stylesheets/tools';

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateX(100%);
  }
  to {
    opacity: 1;
    transform: translateX(0%);
  }
`;

const fadeOut = keyframes`
  from {
    opacity: 1;
    transform: translateX(0%);
  }
  to {
    opacity: 0;
    transform: translateX(100%);
  }
`;

const fadeUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(40px);
  }
  to {
    opacity: 1;
    transform: translateY(0px);
  }
`;

const fadeDown = keyframes`
  from {
    opacity: 1;
    transform: translateY(0px);
  }
  to {
    opacity: 0;
    transform: translateY(40px);
  }
`;

const fadeOpacity = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const fadeOutOpacity = keyframes`
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
`;

const StyledExhibitionTabTeaser = styled.section`
  .tab-teaser {
    background-color: ${getColor('black')};
    padding: ${getSpace('xxl')} 0;

    ${mq('l')} {
      padding: 120px 0 180px 0;
    }

    .tab-teaser__loginMask-open {
      position: relative;
      z-index: 5;
    }

    .tab-teaser__loginMask-open-button {
      pointer-events: all;
      height: 60px;
      width: 60px;
      background: white;
      border-radius: 50%;
      position: relative;
      z-index: 5;
      border: 1px solid black;

      ${mq('s')} {
        height: 70px;
        width: 70px;
      }

      .loginMask__icon {
        height: 100%;
        width: 100%;
      }
    }

    .animate-fadeIn {
      pointer-events: all;

      .loginMask__form-topline {
        animation-duration: 0.5s;
        animation-delay: 0.5s;
        animation-fill-mode: both; /* Corrected typo here */
        animation-name: ${fadeUp};
        animation-timing-function: ease-in-out;
      }
      .tokenInput__instructions {
        animation-duration: 0.5s;
        animation-delay: 0.5s;
        animation-fill-mode: both; /* Corrected typo here */
        animation-name: ${fadeOpacity};
      }
      .loginMask__form-group {
        animation-duration: 0.75s;
        animation-fill-mode: both; /* Corrected typo here */
        animation-name: ${fadeIn};
        animation-timing-function: ease-in-out;
      }
    }

    .animate-fadeOut {
      opacity: 0;
      pointer-events: none;

      .loginMask__form-topline {
        animation-duration: 0.5s;
        animation-fill-mode: both; /* Corrected typo here */
        animation-name: ${fadeDown};
        animation-timing-function: ease-in-out;
      }
      .tokenInput__instructions {
        animation-duration: 0.5s;
        animation-delay: 0.5s;
        animation-fill-mode: both; /* Corrected typo here */
        animation-name: ${fadeOutOpacity};
      }
      .loginMask__form-group {
        animation-duration: 0.75s;
        animation-delay: 0.25s;
        animation-fill-mode: both; /* Corrected typo here */
        animation-name: ${fadeOut};
        animation-timing-function: ease-in-out;
      }
    }

    .tab-teaser__sticky {
      pointer-events: none;
      margin-left: auto;
      position: sticky;
      z-index: 5;
      padding: 0 20px;
      margin-bottom: 40px;
      top: 100px;
      width: 100%;

      ${mq('s')} {
        max-width: 400px;
        margin-bottom: 60px;
        padding: 0;
        right: 40px;
        top: 100px;
      }

      .tab-teaser__loginMask-close {
        width: 100%;
        display: flex;
        justify-content: flex-end;
        margin-bottom: -88px;
        padding-top: 28px;

        ${mq('s')} {
          margin-bottom: -106px;
          padding-top: 32px;
        }
      }
    }

    .tab-teaser__content-image {
      .shaped-image__container {
        &:before {
          left: -6px;

          ${mq('l')} {
            left: -12px;
          }
        }
        .shaped-image__item {
          height: 160px;
          object-fit: cover;

          ${mq('s')} {
            height: 360px;
          }
          ${mq('l')} {
            height: 560px;
          }
        }
      }
    }

    .tab-teaser__content {
      padding-top: ${getSpace('xl')};

      ${mq('l')} {
        padding-top: ${getSpace('xxl')};
      }

      .tab-teaser__content-text {
        max-width: 980px;
        margin: 0 auto;
        padding-top: ${getSpace('xl')};
        ${gridContainer()}
        ${setGridColumns('1fr', 1)}
        gap: 20px;

        ${mq('m')} {
          gap: 30px;
          padding-top: ${getSpace('xxxl')};
          ${setGridColumns('1fr', 2)}
        }

        .tab-teaser__content-text-headline {
          color: ${props => props.theme.globalTheme.primary};

          h3 {
            margin-bottom: 8px;
          }
        }
        .tab-teaser__content-text-description {
          color: ${getColor('white')};

          .tab-teaser__content-link {
            color: ${props => props.theme.globalTheme.primary};
            margin-top: ${getSpace('xs')};
            display: block;
          }
        }
      }
    }
    .tab-teaser__nav {
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      gap: 20px;

      ${mq('l')} {
        gap: 40px;
      }

      .tab-teaser__nav-item {
        position: relative;
        padding: 4px 0;

        ${mq('l')} {
          padding: 6px 0;
        }

        &-underline {
          position: absolute;
          content: '';
          display: block;
          height: 3px;
          width: 100%;
          bottom: 0;
          left: 0;
          background-color: currentColor;
        }

        &:not(.is--active) {
          color: ${getColor('darkGray')};
        }

        &.is--active {
          color: ${props => props.theme.globalTheme.primary};
        }
      }
    }
  }
`;

export default StyledExhibitionTabTeaser;
